module.exports = __webpack_public_path__ + "img/boss.204dacd1.png";